import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useState } from "react";

// Images
import defaultUser from "assets/images/default-user.jpg";
import { useDispatch } from "react-redux";
import { pendingAction } from "store/slice/dealersSlice";

export default function data({dealers = [], dispatch, handleRejectClick}) {

  const Author = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const ShiftData =  {
    1: "Morning",
    2: "Night",
    3: "Full",
    4: "Part Time"
  }

  const rows = dealers.map((dealer) => {

    return {
      dealer: <Author image={defaultUser} name={dealer.name} email={dealer.email} />,
      email: dealer.email,
      schedule: dealer.workdays      + ' - ' + dealer.restDays,
      shift: ShiftData[dealer.shift],
      phone: dealer.phone,
      approve: (
        <IconButton
          color="success"
          onClick={() => dispatch(pendingAction({ dealerId: dealer.id, approved: 1 }))}
        >
          <CheckIcon />
        </IconButton>
      ),
      reject: (
        <IconButton color="error" onClick={() => handleRejectClick(dealer)}>
          <CloseIcon />
        </IconButton>
      ),
    };
  });

  return {
    columns: [
      { Header: "dealer", accessor: "dealer", width: "45%", align: "left" },
      { Header: "email", accessor: "email", align: "left" },
      { Header: "schedule", accessor: "schedule", align: "left" },
      { Header: "shift", accessor: "shift", align: "left" },
      { Header: "phone", accessor: "phone", align: "left" },
      { Header: "approve", accessor: "approve", align: "center" },
      { Header: "reject", accessor: "reject", align: "center" },
    ],

    rows: rows,
  };
}